export const authKeys = {
  all: ['auth'] as const,
  bootstrap: () => [...authKeys.all, 'bootstrap'] as const,
  profile: () => [...authKeys.all, 'profile'] as const,
};

